import { useState, useEffect } from 'react'
import { client } from '../sanity/client'

export function useCareerEvents() {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    console.log('Fetching career events...')
    client
      .fetch(`*[_type == "careerEvent"] | order(monthIndex asc) {
        title,
        type,
        monthIndex,
        color,
        description,
        image,
        "imageExtension": image.asset->extension,
        "imageUrl": image.asset->url,
        "imageGallery": images[],
        detailedDescription,
        techStack,
        outcomes,
        links,
        endMonthIndex
      }`)
      .then(data => {
        console.log('Career events received:', data)
        // Convert array to object keyed by monthIndex
        const eventsObj = {}
        data.forEach(event => {
          eventsObj[event.monthIndex] = event
        })
        console.log('Events object:', eventsObj)
        setEvents(eventsObj)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching career events:', err)
        setLoading(false)
      })
  }, [])

  return { events, loading }
}
